import { Navigate, useParams } from 'react-router-dom';
import GenericAnalysisPage from '../components/analytics/GenericAnalysisPage';
import { ANALYSIS_CONFIGS } from '../components/analytics/analysisConfigs';

export default function AnalyticsDetailPage() {
  const { id } = useParams();
  const cfg = ANALYSIS_CONFIGS[id];
  if (!cfg) return <Navigate to="/analytika" replace />;
  return <GenericAnalysisPage key={id} cfg={cfg} />;
}
